import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthLayout from "../../components/layout/AuthLayout";
import { useAuth } from "../../context/AuthContext";

const Register = () => {
  const { signUp } = useAuth(); // Fungsi Daftar dari Sistem Keamanan

  // --- MEMORI (STATE): Menyimpan data pendaftaran ---
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
    storeName: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  /**
   * --- LOGIKA: Mencatat Ketikan ---
   */
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
    if (error) setError("");
  };

  /**
   * --- LOGIKA UTAMA: Proses Pendaftaran ---
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Validasi: Apakah Password dan Konfirmasi sudah sama?
    if (formData.password !== formData.confirmPassword) {
      return setError("Kata sandi tidak cocok");
    }

    setLoading(true);
    try {
      // Memanggil fungsi keamanan untuk mendaftarkan akun baru
      const { data, error: signUpError } = await signUp(
        formData.email,
        formData.password,
        {
          full_name: formData.fullName, // Menyimpan Nama Lengkap ke Profil
          store_name: formData.storeName, // Menyimpan Nama Toko Utama
        },
      );

      if (signUpError) {
        console.error("Supabase Sign Up Error:", signUpError);
        throw signUpError;
      }

      // Jika berhasil, arahkan langsung ke Beranda (Dashboard) karena email verifikasi dimatikan
      if (data?.user) {
        navigate("/dashboard");
      }
    } catch (err) {
      console.error("Registration Catch Error:", err);
      setError(err.message || "Terjadi kesalahan saat pendaftaran");
    } finally {
      setLoading(false);
    }
  };


  // --- TAMPILAN: Formulir Pendaftaran ---
  return (
    <AuthLayout>
      <div className="max-w-xl w-full grid grid-cols-1 lg:grid-cols-1 gap-12 items-center">
        <div className="bg-surface-container-lowest p-10 lg:p-12 rounded-xl ambient-bloom relative">
          <div className="mb-10">
            <h2 className="font-headline font-bold text-2xl text-on-surface mb-2">
              Buat Akun
            </h2>
          </div>

          {/* AREA NOTIFIKASI ERROR */}
          {error && (
            <div className="mb-6 p-4 bg-error/10 border border-error/20 rounded-lg flex items-center gap-3 text-error text-sm">
              <span className="material-symbols-outlined text-lg">error</span>
              {error}
            </div>
          )}

          <form className="space-y-6" onSubmit={handleSubmit}>
            {/* Input Nama Lengkap */}
            <div className="space-y-1.5">
              <label
                className="font-label text-[11px] uppercase tracking-wider font-semibold text-on-surface-variant px-1"
                htmlFor="fullName"
              >
                Nama Lengkap
              </label>
              <input
                className="w-full bg-surface-container-highest border-none rounded-md px-4 py-3 text-on-surface placeholder:text-outline/50 focus:ring-2 focus:ring-primary-fixed-dim transition-all outline-none"
                id="fullName"
                placeholder="Johnathan Doe"
                type="text"
                required
                value={formData.fullName}
                onChange={handleChange}
              />
            </div>

            {/* Input Nama Toko */}
            <div className="space-y-1.5">
              <label
                className="font-label text-[11px] uppercase tracking-wider font-semibold text-on-surface-variant px-1"
                htmlFor="storeName"
              >
                Nama Toko
              </label>
              <input
                className="w-full bg-surface-container-highest border-none rounded-md px-4 py-3 text-on-surface placeholder:text-outline/50 focus:ring-2 focus:ring-primary-fixed-dim transition-all outline-none"
                id="storeName"
                placeholder="Toko Saya"
                type="text"
                required
                value={formData.storeName}
                onChange={handleChange}
              />
            </div>

            {/* Input Email */}
            <div className="space-y-1.5">
              <label
                className="font-label text-[11px] uppercase tracking-wider font-semibold text-on-surface-variant px-1"
                htmlFor="email"
              >
                Email
              </label>
              <input
                className="w-full bg-surface-container-highest border-none rounded-md px-4 py-3 text-on-surface placeholder:text-outline/50 focus:ring-2 focus:ring-primary-fixed-dim transition-all outline-none"
                id="email"
                placeholder="your@email.com"
                type="email"
                required
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            {/* Baris Input Password & Konfirmasi */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-1.5">
                <label
                  className="font-label text-[11px] uppercase tracking-wider font-semibold text-on-surface-variant px-1"
                  htmlFor="password"
                >
                  Password
                </label>
                <input
                  className="w-full bg-surface-container-highest border-none rounded-md px-4 py-3 text-on-surface focus:ring-2 focus:ring-primary-fixed-dim transition-all outline-none"
                  id="password"
                  placeholder="••••••••"
                  type="password"
                  required
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>
              <div className="space-y-1.5">
                <label
                  className="font-label text-[11px] uppercase tracking-wider font-semibold text-on-surface-variant px-1"
                  htmlFor="confirmPassword"
                >
                  Konfirmasi Password
                </label>
                <input
                  className="w-full bg-surface-container-highest border-none rounded-md px-4 py-3 text-on-surface focus:ring-2 focus:ring-primary-fixed-dim transition-all outline-none"
                  id="confirmPassword"
                  placeholder="••••••••"
                  type="password"
                  required
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Tombol Eksekusi Daftar */}
            <div className="pt-4 space-y-6">
              <button
                className="w-full primary-gradient text-on-primary font-headline font-bold py-4 rounded-lg hover:opacity-90 active:scale-[0.98] transition-all shadow-lg shadow-primary/20 disabled:opacity-50"
                type="submit"
                disabled={loading}
              >
                {loading ? "Membuat Akun..." : "Daftar"}
              </button>
              <div className="text-center">
                <p className="text-xs text-on-surface-variant">
                  Sudah punya akun?
                  <Link
                    className="text-primary font-bold ml-1 hover:underline"
                    to="/login"
                  >
                    Masuk
                  </Link>
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </AuthLayout>
  );
};

export default Register;
